export default class PhysicianOrder {
  patientChartId: number;
  physicianOrder: string;

  constructor(patientChartId: number, physicianOrder: string) {
    this.patientChartId = patientChartId;
    this.physicianOrder = physicianOrder;
  }

  formattedPhysicianOrder = (): string => {
    if (this.physicianOrder) {
      return this.physicianOrder.replace(/_/g, " ");
    }
  };
}



// WEBPACK FOOTER //
// ./src/models/resource-management/physician-order.model.ts